import {createContext,useContext,useState,type ReactNode} from 'react';
import {useSession} from './session.tsx';
import {useOp} from './api.ts';
const Scope=createContext<{channelId:string;selectChannel:(id:string)=>void}>({channelId:'',selectChannel:()=>{}});
export function ChannelScopeProvider({children}:{children:ReactNode}) {
 const {workspace}=useSession();
 return <WorkspaceScope key={workspace.id} workspaceId={workspace.id}>{children}</WorkspaceScope>;
}
function WorkspaceScope({children,workspaceId}:{children:ReactNode;workspaceId:string}) {
 const key=`promptcut.channel.${workspaceId}`;
 const [selected,setSelected]=useState(()=>{try{return localStorage.getItem(key)??'';}catch{return '';}});
 const channels=useOp('workspace.channel_list',{workspace_id:workspaceId});
 const channelId=channels.data&&!channels.data.items.some(c=>c.id===selected)?'':selected;
 return <Scope.Provider value={{channelId,selectChannel:id=>{setSelected(id);try{localStorage.setItem(key,id);}catch{/* Session preference remains usable. */}}}}>{children}</Scope.Provider>;
}
export const useChannelScope=()=>useContext(Scope);
